export const sources={};export const img={src:"__VITE_ASSET__qZZZ7EOcQU0bnm2SE9d1Ig__",w:640,h:640};export default{sources:sources,img:img};